(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$timeout', 'EmailList', 'Auth', 'LoginService', 'errorConstants', '$state', '$rootScope', '$scope', 'password_pattern', '$http', 'AlertService', 'vcRecaptchaService', '$window'];

    function RegisterController($timeout, EmailList, Auth, LoginService, errorConstants, $state, $rootScope, $scope, passwordPattern, $http, AlertService, vcRecaptchaService, $window) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            angular.element(document).find('body').addClass('register-open')
        });

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {
            countryCode: ""
        };
        vm.success = null;
        vm.emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;                
        vm.passwordExcudedEmailPattern = null;
        vm.reCaptchaPublicKey = reCaptchaPublicKey;
        vm.reCaptchaSize = 'invisible';
        vm.countryCodes = [
            { value: "USA (+1)", label: "USA (+1)" },
            { value: "Argentina (+54)", label: "Argentina (+54)" },
            { value: "Aruba (+297)", label: "Aruba (+297)" },
            { value: "Australia (+61)", label: "Australia (+61)" },
            { value: "Austria (+43)", label: "Austria (+43)" },
            { value: "Bahrain (+973)", label: "Bahrain (+973)" },
            { value: "Barbados (+1246)", label: "Barbados (+1246)" },
            { value: "Belarus (+375)", label: "Belarus (+375)" },
            { value: "Belgium (+32)", label: "Belgium (+32)" },
            { value: "Belize (+501)", label: "Belize (+501)" },
            { value: "Bermuda (+1441)", label: "Bermuda (+1441)" },
            { value: "Brazil (+55)", label: "Brazil (+55)" },
            { value: "British Virgin Islands (+1284)", label: "British Virgin Islands (+1284)" },
            { value: "Canada (+1)", label: "Canada (+1)" },
            { value: "Chile (+56)", label: "Chile (+56)" },
            { value: "China (+86)", label: "China (+86)" },
            { value: "Colombia (+57)", label: "Colombia (+57)" },
            { value: "Costa Rica (+506)", label: "Costa Rica (+506)" },
            { value: "Croatia (+385)", label: "Croatia (+385)" },
            { value: "Cyprus (+357)", label: "Cyprus (+357)" },
            { value: "Czech Republic (+420)", label: "Czech Republic (+420)" },
            { value: "Denmark (+45)", label: "Denmark (+45)" },
            { value: "Dominican Republic (+1809)", label: "Dominican Republic (+1809)" },
            { value: "Ecuador (+593)", label: "Ecuador (+593)" },
            { value: "Egypt (+20)", label: "Egypt (+20)" },
            { value: "El Salvador (+503)", label: "El Salvador (+503)" },
            { value: "Estonia (+372)", label: "Estonia (+372)" },
            { value: "Fiji (+679)", label: "Fiji (+679)" },
            { value: "Finland (+358)", label: "Finland (+358)" },
            { value: "France (+33)", label: "France (+33)" },
            { value: "French Guiana (+594)", label: "French Guiana (+594)" },
            { value: "French Polynesia (+689)", label: "French Polynesia (+689)" },
            { value: "Georgia (+995)", label: "Georgia (+995)" },
            { value: "Germany (+49)", label: "Germany (+49)" },
            { value: "Gibraltar (+350)", label: "Gibraltar (+350)" },
            { value: "Greece (+30)", label: "Greece (+30)" },
            { value: "Greenland (+299)", label: "Greenland (+299)" },
            { value: "Hong Kong (SAR) (+852)", label: "Hong Kong (SAR) (+852)" },
            { value: "Hungary (+36)", label: "Hungary (+36)" },
            { value: "Iceland (+354)", label: "Iceland (+354)" },
            { value: "India (+91)", label: "India (+91)" },
            { value: "Indonesia (+62)", label: "Indonesia (+62)" },
            { value: "Ireland (+353)", label: "Ireland (+353)" },
            { value: "Israel (+972)", label: "Israel (+972)" },
            { value: "Italy (+39)", label: "Italy (+39)" },
            { value: "Jamaica (+1876)", label: "Jamaica (+1876)" },
            { value: "Japan (+81)", label: "Japan (+81)" },
            { value: "Jordan (+962)", label: "Jordan (+962)" },
            { value: "Kenya (+254)", label: "Kenya (+254)" },
            { value: "South (+82)", label: "Korea" },
            { value: "Kuwait (+965)", label: "Kuwait (+965)" },
            { value: "Latvia (+371)", label: "Latvia (+371)" },
            { value: "Lebanon (+961)", label: "Lebanon (+961)" },
            { value: "Luxembourg (+352)", label: "Luxembourg (+352)" },
            { value: "Malaysia (+60)", label: "Malaysia (+60)" },
            { value: "Mauritius (+230)", label: "Mauritius (+230)" },
            { value: "Mexico (+52)", label: "Mexico (+52)" },
            { value: "Morocco (+212)", label: "Morocco (+212)" },
            { value: "Nepal (+977)", label: "Nepal (+977)" },
            { value: "Netherlands (+31)", label: "Netherlands (+31)" },
            { value: "Netherlands Antilles (+599)", label: "Netherlands Antilles (+599)" },
            { value: "Nigeria (+234)", label: "Nigeria (+234)" },
            { value: "Norway (+47)", label: "Norway (+47)" },
            { value: "Oman (+968)", label: "Oman (+968)" },
            { value: "Pakistan (+92)", label: "Pakistan (+92)" },
            { value: "Panama (+507)", label: "Panama (+507)" },
            { value: "Papua New Guinea (+675)", label: "Papua New Guinea (+675)" },
            { value: "Paraguay (+595)", label: "Paraguay (+595)" },
            { value: "Peru (+51)", label: "Peru (+51)" },
            { value: "Philippines (+63)", label: "Philippines (+63)" },
            { value: "Poland (+48)", label: "Poland (+48)" },
            { value: "Portugal (+351)", label: "Portugal (+351)" },
            { value: "Puerto Rico (+1787)", label: "Puerto Rico (+1787)" },
            { value: "Qatar (+974)", label: "Qatar (+974)" },
            { value: "Romania (+40)", label: "Romania (+40)" },
            { value: "Russian Federation (+7)", label: "Russian Federation (+7)" },
            { value: "Saudi Arabia (+966)", label: "Saudi Arabia (+966)" },
            { value: "Singapore (+65)", label: "Singapore (+65)" },
            { value: "South Africa (+27)", label: "South Africa (+27)" },
            { value: "South Sudan (+211)", label: "South Sudan (+211)" },
            { value: "Spain (+34)", label: "Spain (+34)" },
            { value: "Sri Lanka (+94)", label: "Sri Lanka (+94)" },
            { value: "Sweden (+46)", label: "Sweden (+46)" },
            { value: "Switzerland (+41)", label: "Switzerland (+41)" },
            { value: "Taiwan (+886)", label: "Taiwan (+886)" },
            { value: "Thailand (+66)", label: "Thailand (+66)" },
            { value: "The Bahamas (+1242)", label: "The Bahamas (+1242)" },
            { value: "Turkey (+90)", label: "Turkey (+90)" },
            { value: "Turkmenistan (+993)", label: "Turkmenistan (+993)" },
            { value: "Turks and Caicos Islands (+1649)", label: "Turks and Caicos Islands (+1649)" },
            { value: "Ukraine (+380)", label: "Ukraine (+380)" },
            { value: "United Arab Emirates (+971)", label: "United Arab Emirates (+971)" },
            { value: "United Kingdom (+44)", label: "United Kingdom (+44)" },
            { value: "Uruguay (+598)", label: "Uruguay (+598)" },
            { value: "Venezuela (+58)", label: "Venezuela (+58)" },
            { value: "Vietnam (+84)", label: "Vietnam (+84)" },
            { value: "Virgin Islands (+1340)", label: "Virgin Islands (+1340)" },
            { value: "Zambia (+260)", label: "Zambia (+260)" },
            { value: "Zimbabwe (+263)", label: "Zimbabwe (+263)" }
        ];


        /* if (angular.element($window).width() < 460) {
             vm.reCaptchaSize = 'compact';
         }*/



        vm.registerAccount.domain = "";
        $http.get("https://api.ipify.org/?format=json").then(function (response) {
            vm.registerAccount.ip = response.data.ip;
        });

        $timeout(function () {
            angular.element('#login').focus();
        });

        $timeout(function () {
            grecaptcha.execute()
        }, 1000);

        setInterval(function () { grecaptcha.reset(); }, 1 * 60 * 1000);

        vm.emailTouched = false;
        vm.emailInvalid = false;
        vm.emailInvalidReason = '';
        
        EmailList.query({}, onSuccess, onError);
        
        vm.checkEmail = function(email) {
            return EmailList.checkEmailDomain(email.split('@')[1])
                .then(function(isBanned) {
                    vm.emailInvalid = isBanned;
                    vm.emailInvalidReason = isBanned ? 'blocked' : '';
                    return isBanned;
                })
                .catch(function(error) {
                    vm.emailInvalid = true;
                    vm.emailInvalidReason = 'error';
                    return true; // Treat errors as if the email is banned
                });
        };
        
        function onSuccess(data) {
            vm.blockedEmailDomains = data.map(function(resource) {
                return resource.domain;
            });
        
            vm.validateEmail = function() {
                vm.emailTouched = true;
                if (!vm.registerAccount) {
                    return;
                }
                var email = vm.registerAccount.email;
        
                if (!email || email.length < 5 || email.length > 100 || !vm.emailPattern.test(email)) {
                    vm.emailInvalid = true;
                    vm.emailInvalidReason = 'format';
                } else {
                    vm.checkEmail(email).then(function(isBanned) {
                        if (!isBanned) {
                            vm.emailInvalid = false;
                            vm.emailInvalidReason = '';
                        }
                    });
                }
            };
        }
        
        function onError(error) {
            console.error('Error fetching email list:', error);
            // Handle error (e.g., show an alert to the user)
        }
        
        function register() {

            /*if($scope.form.$invalid){
                vm.errorValidation = 'ERROR';
            }*/

            vm.registerAccount.langKey = 'en';
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.errorEmailNotAllowed = null;
            vm.registerAccount.login = vm.registerAccount.email;

            vm.registerAccount.firstName = vm.registerAccount.firstName;
            vm.registerAccount.domain = 'demo' + vm.registerAccount.login;

            Auth.createAccount(vm.registerAccount).then(function () {
                vm.success = 'OK';
                Auth.login({
                    username: vm.registerAccount.login,
                    password: vm.registerAccount.password,
                    rememberMe: false
                }).then(function () {
                    vm.authenticationError = false;
                    //$state.go('instance-dbh');

                    authClient.signIn({ username: vm.registerAccount.login, password: vm.registerAccount.password })
                        .then(function (res) {
                            if (res.status === 'SUCCESS') {
                                $rootScope.$broadcast('authenticationSuccess');

                                authClient.token.getWithRedirect({
                                    sessionToken: res.sessionToken,
                                    responseType: 'id_token'
                                });
                            }
                        }).fail(function (err) {
                            console.error(err);
                        });

                }).catch(function () {
                    vm.authenticationError = true;
                });
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                    vm.errorUserExists = 'ERROR';
                } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                    vm.errorEmailExists = 'ERROR';
                } else if (vm.error === 'EMAIL_NOT_ALLOWED') {
                    vm.errorEmailNotAllowed = 'ERROR';
                }
                /*else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.COMPANY_ALREADY_USED_TYPE) {
                    vm.errorCompanyExists = 'ERROR';
                }*/
                else {
                    vm.error = 'ERROR';
                }
            });
        }

        vm.loginPage = function () {
            $state.go('signin');
        }

        /*vm.processDomain = function () {
            vm.registerAccount.domain = vm.registerAccount.firstName.replace(/[^a-z0-9]/gi, '').toLowerCase();
        }*/

        vm.getPasswordPattern = function () {
            if (vm.registerAccount.email) {
                if (!vm.passwordExcudedEmailPattern) {
                    var passPattern = passwordPattern + "";
                    vm.passwordExcudedEmailPattern = new RegExp(passPattern.slice(1, -1) + "(?!.*" + vm.registerAccount.email + ")");
                }
                return vm.passwordExcudedEmailPattern;

            } else {
                return passwordPattern;
            }
        }

    }
})();
